<script setup>
import { useNetworkStore } from '../stores/network.js';

const network = useNetworkStore();
</script>

<template>
  <Transition name="offline">
    <div v-if="!network.isConnected" class="offline-overlay" role="alert">
      <div class="offline-inner">
        <div class="offline-icon" aria-hidden="true">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <line x1="1" y1="1" x2="23" y2="23" />
            <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
            <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
            <path d="M10.71 5.05A16 16 0 0 1 22.56 9" />
            <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
            <circle cx="12" cy="20" r="1" fill="currentColor" />
          </svg>
        </div>
        <p class="offline-title">No Connection</p>
        <p class="offline-body">Check your network before continuing.<br />The POS requires an active connection.</p>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.offline-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: oklch(0% 0 0 / 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.offline-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  max-width: 320px;
  text-align: center;
}

.offline-icon {
  color: var(--bc-neon-pink);
  opacity: 0.85;
}

.offline-title {
  font-family: var(--bc-font-display);
  font-size: 2rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: -0.02em;
  color: var(--bc-text);
  margin: 0;
}

.offline-body {
  font-family: var(--bc-font-ui);
  font-size: var(--bc-text-sm);
  color: var(--bc-text-muted);
  margin: 0;
  line-height: 1.6;
}

/* Transition */
.offline-enter-active { transition: opacity 0.2s; }
.offline-leave-active { transition: opacity 0.3s; }
.offline-enter-from, .offline-leave-to { opacity: 0; }
</style>
